var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-comments-body" }, [
    _c("div", { staticClass: "go-block-wrap" }, [
      _c(
        "div",
        { staticClass: "go-block-header" },
        [
          _c("TotalCommentsCnt", {
            scopedSlots: _vm._u(
              [
                {
                  key: "total",
                  fn: function () {
                    return [_vm._t("total")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c("div", { staticClass: "go-comments-select" }, [
            _vm.userId === _vm.ownerId
              ? _c("div", { staticClass: "custom-control custom-checkbox" }, [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck-all" },
                    on: { change: _vm.onChangePrivate },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customCheck-all" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.t("briefing.comment.private")) +
                          "\n          "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "go-filter-item" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn go-btn-icon",
                  on: { click: _vm.onChangeSort },
                },
                [
                  _c("i", {
                    staticClass: "go-icon-22 go-icon-sort-descending",
                  }),
                  _vm._v(" "),
                  _c("em", [
                    _vm._v(
                      _vm._s(
                        _vm.sortMode
                          ? _vm.t("briefing.comment.latest")
                          : _vm.t("briefing.comment.oldest")
                      )
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.comments && _vm.comments.length > 0
        ? _c(
            "div",
            { staticClass: "go-block-body" },
            _vm._l(_vm.comments, function (comment, idx) {
              return _c(
                "div",
                { key: "comment-" + idx, staticClass: "go-list-item" },
                [
                  _c("div", { staticClass: "go-comments-view" }, [
                    _c("ol", { staticClass: "go-comments-info" }, [
                      _c("li", [
                        _c("div", { staticClass: "go-card-info" }, [
                          _c(
                            "a",
                            {
                              staticClass: "go-info-item go-user-info",
                              attrs: { href: "#" },
                            },
                            [
                              _c("div", { staticClass: "go-user-thumb" }, [
                                comment.userAvatar
                                  ? _c("img", {
                                      attrs: {
                                        src: comment.userAvatar,
                                        alt: "userAvatar",
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "go-user-id" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(comment.userName) +
                                    "\n                  "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "go-info-item go-datetime" },
                            [
                              _c("em", { staticClass: "go-text" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.convertDate(comment.createdDate)
                                    ) +
                                    "\n                  "
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.isGuest && _vm.userId === comment.userId
                        ? _c("li", [
                            _c("div", { staticClass: "go-btn-area" }, [
                              _c(
                                "div",
                                { staticClass: "go-dropdown-group dropdown" },
                                [
                                  _vm._m(0, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                    },
                                    [
                                      !_vm.isModifyMode
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.edit(comment)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-18 go-icon-edit-2",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "go-text" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.t(
                                                            "briefing.comment.modify"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.remove(comment)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-18 go-icon-trash",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "go-text" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.t(
                                                            "briefing.comment.remove"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm.isModifyMode &&
                                          _vm.selectedModifyCommentId ===
                                            comment.id
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "dropdown-item",
                                                on: { click: _vm.cancelEdit },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-18 go-icon-reload-2",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "go-text" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.t(
                                                            "briefing.comment.cancel"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-comments-contents" }, [
                      _c(
                        "div",
                        { staticClass: "go-comments-block" },
                        [
                          _vm.isModifyMode &&
                          _vm.selectedModifyCommentId === comment.id
                            ? _c("ModifyComment", {
                                attrs: {
                                  "check-id": comment.id,
                                  comment: comment,
                                },
                                on: { getAllComments: _vm.getAllComments },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isModifyMode ||
                          _vm.selectedModifyCommentId !== comment.id
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "go-comments-desc" },
                                  [
                                    comment.isPrivate === _vm.PUBLIC
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "comment-text",
                                              class: {
                                                expanded:
                                                  _vm.expandedComments.includes(
                                                    comment.id
                                                  ),
                                              },
                                              attrs: {
                                                id:
                                                  "comment-text-" + comment.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(comment.content) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.overflowComments.includes(
                                            comment.id
                                          )
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleExpand(
                                                        comment.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("a", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.expandedComments.includes(
                                                          comment.id
                                                        )
                                                          ? _vm.$t(
                                                              "briefing.comment.collapse"
                                                            )
                                                          : _vm.$t(
                                                              "briefing.comment.expand"
                                                            )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-18 go-icon-20",
                                                    class:
                                                      _vm.expandedComments.includes(
                                                        comment.id
                                                      )
                                                        ? "go-icon-chevron-up"
                                                        : "go-icon-chevron-down",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : comment.isPrivate === _vm.PRIVATE &&
                                        (_vm.userId === comment.userId ||
                                          _vm.userId === _vm.ownerId)
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "comment-text",
                                              class: {
                                                expanded:
                                                  _vm.expandedComments.includes(
                                                    comment.id
                                                  ),
                                              },
                                              attrs: {
                                                id:
                                                  "comment-text-" + comment.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(comment.content) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.overflowComments.includes(
                                            comment.id
                                          )
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleExpand(
                                                        comment.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("a", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.expandedComments.includes(
                                                          comment.id
                                                        )
                                                          ? _vm.t(
                                                              "briefing.comment.collapse"
                                                            )
                                                          : _vm.t(
                                                              "briefing.comment.expand"
                                                            )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-18 go-icon-20",
                                                    class:
                                                      _vm.expandedComments.includes(
                                                        comment.id
                                                      )
                                                        ? "go-icon-chevron-up"
                                                        : "go-icon-chevron-down",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t(
                                                  "briefing.comment.viewOnly"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "go-comments-option" },
                                  [
                                    _c(
                                      "li",
                                      [
                                        comment.isPrivate === 1
                                          ? _c(
                                              "div",
                                              { staticClass: "go-elements" },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "icon-private",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "go-icon-20 go-icon-private",
                                                    }),
                                                    _vm._v(" "),
                                                    _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.t(
                                                            "briefing.comment.private"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("LikeAndDislike", {
                                          attrs: {
                                            comment: comment,
                                            userId: _vm.userId,
                                            isGuest: _vm.isGuest,
                                          },
                                          on: {
                                            onClickLike: _vm.onClickLike,
                                            onClickDislike: _vm.onClickDislike,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "go-elements" },
                                          [
                                            _c("ShowFiles", {
                                              attrs: { comment: comment },
                                            }),
                                            _vm._v(" "),
                                            _c("ShowImages", {
                                              attrs: { comment: comment },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "go-elements" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-btn-reply collapsed",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "collapse",
                                                  "data-target":
                                                    "#go-comments-area-" + idx,
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-20 go-icon-reply",
                                                }),
                                                _vm._v(" "),
                                                _c("em", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("report.reply")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    comment.children.length
                                      ? _c("li", [
                                          _c(
                                            "div",
                                            { staticClass: "go-elements" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn go-btn-replies collapsed",
                                                  attrs: {
                                                    type: "button",
                                                    "data-toggle": "collapse",
                                                    "data-target":
                                                      "#go-comments-reply-" +
                                                      idx,
                                                    "aria-expanded": "false",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "report.replies",
                                                          {
                                                            total:
                                                              comment.children
                                                                .length,
                                                          }
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-18 go-icon-chevron-up",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse",
                                    attrs: { id: "go-comments-area-" + idx },
                                  },
                                  [
                                    _vm._t("commentInComment", null, {
                                      parentId: comment.id,
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      comment.children && comment.children.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "go-comments-contents reply collapse",
                              attrs: { id: "go-comments-reply-" + idx },
                            },
                            _vm._l(comment.children, function (child) {
                              return _c(
                                "div",
                                {
                                  key: "child-" + child.id,
                                  staticClass: "go-comments-block",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "go-comments-view" },
                                    [
                                      _c(
                                        "ol",
                                        { staticClass: "go-comments-info" },
                                        [
                                          _c("li", [
                                            _c(
                                              "div",
                                              { staticClass: "go-card-info" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "go-info-item go-user-info",
                                                    attrs: { href: "#" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-user-thumb",
                                                      },
                                                      [
                                                        child.userAvatar
                                                          ? _c("img", {
                                                              attrs: {
                                                                src: child.userAvatar,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-user-id",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              child.userName
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-info-item go-datetime",
                                                  },
                                                  [
                                                    _c(
                                                      "em",
                                                      {
                                                        staticClass: "go-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.convertDate(
                                                                child.createdDate
                                                              )
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "div",
                                              { staticClass: "go-btn-area" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "dropdown" },
                                                  [
                                                    _vm._m(1, true),
                                                    _vm._v(" "),
                                                    !_vm.isGuest &&
                                                    _vm.userId === child.userId
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-menu dropdown-menu-right",
                                                          },
                                                          [
                                                            !_vm.isSubModifyMode
                                                              ? [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.editSub(
                                                                              child
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18 go-icon-edit-2",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.t(
                                                                                "briefing.comment.modify"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.remove(
                                                                              child
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18 go-icon-trash",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.t(
                                                                                  "briefing.comment.remove"
                                                                                )
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm.isSubModifyMode &&
                                                                _vm.selectedModifyCommentId ===
                                                                  child.id
                                                              ? [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      on: {
                                                                        click:
                                                                          _vm.cancelEdit,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18 go-icon-reload-2",
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.t(
                                                                                "briefing.comment.cancel"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "go-comments-contents" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "go-comments-block",
                                            },
                                            [
                                              _vm.isSubModifyMode &&
                                              _vm.selectedModifyCommentId ===
                                                child.id
                                                ? _c("ModifyComment", {
                                                    attrs: {
                                                      "check-id": child.id,
                                                      comment: child,
                                                    },
                                                    on: {
                                                      getAllComments:
                                                        _vm.getAllComments,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isSubModifyMode ||
                                              _vm.selectedModifyCommentId !==
                                                child.id
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-comments-desc",
                                                      },
                                                      [
                                                        child.isPrivate ===
                                                        _vm.PUBLIC
                                                          ? [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "comment-text",
                                                                  class: {
                                                                    expanded:
                                                                      _vm.expandedComments.includes(
                                                                        child.id
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "comment-text-" +
                                                                      child.id,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        child.content
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.overflowComments.includes(
                                                                child.id
                                                              )
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "toggle-expand",
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                        },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.toggleExpand(
                                                                              child.id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("a", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.expandedComments.includes(
                                                                              child.id
                                                                            )
                                                                              ? _vm.t(
                                                                                  "briefing.comment.collapse"
                                                                                )
                                                                              : _vm.t(
                                                                                  "briefing.comment.expand"
                                                                                )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18 go-icon-20",
                                                                        class:
                                                                          _vm.expandedComments.includes(
                                                                            child.id
                                                                          )
                                                                            ? "go-icon-chevron-up"
                                                                            : "go-icon-chevron-down",
                                                                      }),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          : child.isPrivate ===
                                                              _vm.PRIVATE &&
                                                            (_vm.userId ===
                                                              child.userId ||
                                                              _vm.userId ===
                                                                _vm.ownerId)
                                                          ? [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "comment-text",
                                                                  class: {
                                                                    expanded:
                                                                      _vm.expandedComments.includes(
                                                                        child.id
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "comment-text-" +
                                                                      child.id,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        child.content
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.overflowComments.includes(
                                                                child.id
                                                              )
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                        },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.toggleExpand(
                                                                              child.id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("a", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.expandedComments.includes(
                                                                              child.id
                                                                            )
                                                                              ? _vm.t(
                                                                                  "briefing.comment.collapse"
                                                                                )
                                                                              : _vm.t(
                                                                                  "briefing.comment.expand"
                                                                                )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "go-icon-18 go-icon-20",
                                                                        class:
                                                                          _vm.expandedComments.includes(
                                                                            child.id
                                                                          )
                                                                            ? "go-icon-chevron-up"
                                                                            : "go-icon-chevron-down",
                                                                      }),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          : [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.t(
                                                                      "briefing.comment.viewOnly"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "go-comments-option",
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          [
                                                            child.isPrivate ===
                                                            1
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "go-elements",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "icon-private",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "go-icon-20 go-icon-private",
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "em",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.t(
                                                                                  "briefing.comment.private"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "LikeAndDislike",
                                                              {
                                                                attrs: {
                                                                  comment:
                                                                    child,
                                                                  userId:
                                                                    _vm.userId,
                                                                  isGuest:
                                                                    _vm.isGuest,
                                                                },
                                                                on: {
                                                                  onClickLike:
                                                                    _vm.onClickLike,
                                                                  onClickDislike:
                                                                    _vm.onClickDislike,
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-elements",
                                                              },
                                                              [
                                                                _c(
                                                                  "ShowFiles",
                                                                  {
                                                                    attrs: {
                                                                      comment:
                                                                        child,
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "ShowImages",
                                                                  {
                                                                    attrs: {
                                                                      comment:
                                                                        child,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn go-btn-icon",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-more-dot" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn go-btn-icon",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-more-dot" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }